export default {
  name: 'transaction_informations_terms_of_use',
  component_path: 'modules/procedures/blocks/informations/BlockTermsOfUse',
  static_mandatory: ['terms:true']
}